if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

toggleSubmitButton(disable = true, text) {
        const sectionContainer = this.closest('.section-sections__main-product-button' || '.product');
        const closestSectionId = sectionContainer ? sectionContainer.dataset.section : this.submitButton.closest('[id^="MainProduct-"]')?.id?.replace('MainProduct-', '');
        
        const quantityWrapper = document.querySelector(`#Quantity-Form-${closestSectionId}`) || this.closest('.product-info')?.querySelector('.product-form__input--quantity');
        const dynamicCheckout = this.form.querySelector('.shopify-payment-button');

        // Check accurate current real-time variant matrix
        const variantSelect = document.querySelector('variant-selects') || document.querySelector('variant-radios');
        const isTrueSoldOut = disable || (variantSelect && variantSelect.currentVariant && !variantSelect.currentVariant.available);

        if (isTrueSoldOut) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          
          if (quantityWrapper) {
            const qtyInput = quantityWrapper.querySelector('.quantity__input') || quantityWrapper.querySelector('input');
            if (qtyInput) {
              qtyInput.setAttribute('disabled', 'disabled');
            }
            quantityWrapper.style.opacity = '0.6';
            quantityWrapper.style.pointerEvents = 'none';
          }

          if (dynamicCheckout) {
            dynamicCheckout.style.display = 'none';
          }

        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to Cart';

          if (quantityWrapper) {
            const qtyInput = quantityWrapper.querySelector('.quantity__input') || quantityWrapper.querySelector('input');
            if (qtyInput) {
              qtyInput.removeAttribute('disabled');
              
              // Base baseline check to prevent 0 or empty inputs
              const currentVal = parseInt(qtyInput.value);
              if (isNaN(currentVal) || currentVal < 1) {
                qtyInput.value = 1;
              }

              // --- ULTA DATA MISMATCH PERMANENT FIX ---
              // Liquid cache ko bypass karke hum runtime JS currentVariant metadata se direct stock parameters read karenge

              if (variantSelect && variantSelect.currentVariant) {
                const liveStock = variantSelect.currentVariant.inventory_quantity;
                const trackInventory = variantSelect.currentVariant.inventory_management;
                const denyPolicy = variantSelect.currentVariant.inventory_policy;

                if (trackInventory !== null && denyPolicy === 'deny' && liveStock !== undefined) {
                  // Direct HTML attributes overwrite taaki galat step render block na ho
                  qtyInput.setAttribute('max', liveStock);
                  qtyInput.setAttribute('data-max', liveStock);

                  // Agar current selection (7) se automatic down tracking (2) pe crash kare, force reset input value
                  if (parseInt(qtyInput.value) > liveStock) {
                    qtyInput.value = liveStock;
                  }
                } else {
                  qtyInput.removeAttribute('max');
                  qtyInput.removeAttribute('data-max');
                }
              }
            }
            quantityWrapper.style.opacity = '1';
            quantityWrapper.style.pointerEvents = 'auto';
          }

          if (dynamicCheckout) {
            dynamicCheckout.style.display = 'block';
          }
        }
      }
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
